import styled from 'styled-components';
import {
  black,
  border1,
  selected,
  white,
} from '../../../../../../utils/style/colors';
import { Chip } from '../../../../../AssigneeChip/AssigneeChip';

export const Wrapper = styled('div')`
  // display: flex;
  border: ${border1};
  background: var(--exact-white);
  border-radius: 0.5rem;
  margin-top: 10px;
  padding: 10px;
  ${Chip} > span {
    background-color: ${selected};
    color: ${white};
  }
`;

export const Label = styled('label')`
  color: ${black};
  font-size: 14px;
`;
